// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"292b09b6","239":"bf930560","367":"b2e32c64","453":"bfec4eeb","455":"aba44edd","977":"2e36ab9b"}[chunkId] + ".chunk.js";
};